'use client';

import { useRef } from 'react';

import { ChatComposer, type ChatComposerProps } from '@/shared/ui/chat';

import type { ControlsTrack } from '../lib/controls-analytics';
import { useComposerVoice } from '../model/use-composer-voice';

type ComposerProps = Pick<
	ChatComposerProps,
	| 'value'
	| 'onChange'
	| 'onSend'
	| 'commands'
	| 'disabled'
	| 'sendDisabled'
	| 'disabledPlaceholder'
> & { track?: ControlsTrack };

/** Interview behavior; the shared composer owns all markup and styling. */
export function Composer({ track, ...props }: ComposerProps) {
	const fieldRef = useRef<HTMLInputElement | HTMLTextAreaElement | null>(null);
	const voice = useComposerVoice({ ...props, fieldRef, track });
	return (
		<ChatComposer
			{...props}
			ariaLabel="Ответ кандидата"
			fieldRef={fieldRef}
			voice={voice}
			onEngage={() => track?.('input', { action: 'engage' })}
			onCommand={(command, source) =>
				track?.('command', { action: command.id, source, stage: 'intent' })
			}
			onMenuOpenChange={(open, source) =>
				track?.('menu', { action: open ? 'open' : 'close', source })
			}
		/>
	);
}
